<template>
  <piece-card title="部门台账">
    <div class="ledger-body">
      <TabsCard v-model="active" :list="list" />
      <ScreenTable :data="data" :columns="columns" class="table-box" />
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";
import TabsCard from "../../components/tabs-card.vue";
import ScreenTable from "../../components/screen-table.vue";

export default {
  name: "Ledger",
  components: {
    PieceCard,
    TabsCard,
    ScreenTable,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      list: [
        { label: "部门审批", value: 1 },
        { label: "领用设备", value: 2 },
        { label: "今日报车", value: 3 },
        { label: "今日参礼", value: 4 },
      ],
      active: 1,
      columns1: [
        { title: "申请时间", prop: "create_time", align: "center" },
        { title: "应用", prop: "temp_name", align: "center" },
        { title: "申请人", prop: "user_name", align: "center" },
      ],
      columns2: [
        { title: "编码", prop: "asset_code", align: "center" },
        { title: "名称", prop: "device_name", align: "center", render: (value) => value?.name || "--" },
        { title: "保管人", prop: "name", align: "center" },
      ],
      columns3: [
        { title: "下发时间", prop: "create_time", align: "center" },
        { title: "车牌号", prop: "num", align: "center" },
        { title: "联系人", prop: "user_name", align: "center" },
      ],
      columns4: [
        { title: "殿堂", prop: "palace", align: "center", render: (value, item) => item?.detail?.palace || "--" },
        { title: "人数", prop: "count", align: "center", render: (value, item) => item?.detail?.count || "--" },
        { title: "申请人", prop: "user_name", align: "center" },
      ],
    };
  },
  computed: {
    data() {
      let res = [];
      switch (this.active) {
        case 1:
          res = this.info?.bmsp || [];
          break;
        case 2:
          res = this.info?.lysb || [];
          break;
        case 3:
          res = this.info?.jrbc || [];
          break;
        case 4:
          res =
            this.info?.jrcl?.map((item) => {
              try {
                const detail = JSON.parse(item.detail);
                item.detail = detail;
              } catch (e) {
                console.log("jrcl parse detail error:", e);
                item.detail = {};
              }
              return item;
            }) || [];
          break;
      }
      return res;
    },
    columns() {
      let res = [];
      switch (this.active) {
        case 1:
          res = this.columns1;
          break;
        case 2:
          res = this.columns2;
          break;
        case 3:
          res = this.columns3;
          break;
        case 4:
          res = this.columns4;
          break;
      }
      return res;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.table-box {
  height: 286px;
}
</style>
